<template>
    <el-upload
        class="upload"
        ref="upload"
        :action="uploadUrl"
        name="file"
        accept=".png,.jpg"
        :on-remove="handleRemove"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        list-type="picture"
        :file-list="imgList"
    >
        <el-button slot="trigger" size="small" type="primary"
            >选取文件</el-button
        >

        <div slot="tip" class="el-upload__tip">
            只能上传 .png .jpg图片，且不超过10MB
        </div>
    </el-upload>
</template>

<script>
export default {
    props: ['imgList'],
    data() {
        return {
            uploadUrl: "",
            imgUrl: "",
        };
    },
    mounted() {
        this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
    },
    methods: {
        // 从本地保存的上传目录中删除图片路径
        handleRemove(file, fileList) {
            console.log(fileList);
            console.log(file);
            this.imgUrl = fileList;
            this.$emit("removeImg",fileList);
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$message.error("上传文件大小不能超过 10MB!");
            }
            return isLt100M;
        },
        handleSuccess(response) {
            if (response && response.code === 0) {
                console.log("文件上传成功返回结果：", response.data);
                this.imgUrl = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
                this.$emit("imgUploaded", this.imgUrl);
            }
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-upload-list--picture {
    display: flex;
    .el-upload-list__item {
        width: 92px;
        height: 92px;
        margin-left: 10px;
    }
}
</style>